import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIsHouseholdMeasurementEnabled = new ReduxAsyncAction<
  'UPDATE_IS_HOUSEHOLD_MEASUREMENT_ENABLED',
  boolean,
  { isHouseholdMeasurementEnabled: boolean }
>('UPDATE_IS_HOUSEHOLD_MEASUREMENT_ENABLED');

UpdateIsHouseholdMeasurementEnabled.registerRequest(async (isHouseholdMeasurementEnabled: boolean) => {
  return { isHouseholdMeasurementEnabled };
});

export const UPDATE_IS_HOUSEHOLD_MEASUREMENT_ENABLED = UpdateIsHouseholdMeasurementEnabled.actionNamespaceConstants;
export const updateIsHouseholdMeasurementEnabled = UpdateIsHouseholdMeasurementEnabled.request;

export type UpdateIsHouseholdMeasurementEnabledResponseAction = Action<
  typeof UPDATE_IS_HOUSEHOLD_MEASUREMENT_ENABLED.response
> & {
  data: { isHouseholdMeasurementEnabled: boolean };
};
